module.exports = __webpack_public_path__ + "img/Fruits_et_Legumes_2.12ed35e1.jpg";